import { createAction } from 'redux-actions';
import { ADD_ITEM, DELETE_ITEM, LOAD_LAYOUT, UPDATE_ITEM, UPDATE_LAYOUT } from './constants';

export const loadLayout = createAction(
	LOAD_LAYOUT,
);

export interface IAddItemParams {
	options: {
		type: string
		symbol?: string
		width: number
		h: number
	}
}

export const addItem = createAction(
	ADD_ITEM,
	(payload: IAddItemParams) => payload,
);

export interface IUpdateItemParam {
	i: number,
	x: number,
	y: number,
	h: number
	w: number
}

export const updateItem = createAction(
	UPDATE_ITEM,
	(payload: IUpdateItemParam[]) => payload,
);

export interface IDeleteItemParams {
	id: number
}

export const deleteItem = createAction(
	DELETE_ITEM,
	(payload: IDeleteItemParams) => payload,
);

export interface IUpdateLayoutParams {
	key: number
}

export const updateLayout = createAction(
	UPDATE_LAYOUT,
	(payload: IUpdateItemParam) => payload,
);

